<script setup lang="ts">
import { toRefs, computed, type PropType } from 'vue';
import Icon from '@/Partials/Atoms/Icon/Icon.vue';

const propDefines = defineProps({
  class: {
    type: String,
    default: '',
  },
  modifier: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  ariaLabel: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  type: {
    // No caller currently sets this explicitly; narrowed to match the native <button> attribute.
    type: String as PropType<'button' | 'submit' | 'reset'>,
    default: 'button',
  },
});

const props = toRefs(propDefines);

const computedClasses = computed(() => {
  let classes = `btn ${props.class.value}`;

  if (props.modifier.value) {
    classes += ` btn--${props.modifier.value.split(' ').join(' btn--')}`;
  }

  return classes;
});
</script>

<template>
  <button :class="computedClasses" :aria-label="ariaLabel" :disabled="disabled" :type="type">
    <span v-if="props.text.value" class="btn__text">{{ props.text.value }}</span>
    <Icon
      v-if="props.icon.value"
      :key="props.icon.value"
      :name="props.icon.value"
      modifier="btn__icon"
    />
  </button>
</template>
